import { getApiClient, useToast } from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

export interface GlobalAllowanceResponse {
  totalGrossEarnings: number;
  globalAllowance: number;
  availableGlobalAllowance: number;
  globalAllowancePercentage: number;
  totalActiveDeductionsRequestsAmount: number;
}

const useFetchGlobalAllowance = (individualId?: string, enabled = true) => {
  const toast = useToast();

  return useQuery<GlobalAllowanceResponse, Error>(
    ['fetchGlobalAllowance', individualId],
    async () => {
      const response = await getApiClient().get<GlobalAllowanceResponse>(
        `/wallet-manager/salary/deductions-requests/allowance/${individualId}`
      );
      return response.data;
    },
    {
      enabled: !!individualId && enabled,
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: 'Sorry, we failed to fetch the current allowance. Please try again.',
        });
      },
    }
  );
};

export default useFetchGlobalAllowance;
